var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 37
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC02",
    d: "m19 0-4.446 6.998-7.955-2.535 1.144 8.186L0 15.763l6.199 5.544-3.907 7.306 8.352.307L12.401 37 19 31.927 25.599 37l1.757-8.08 8.352-.307-3.906-7.306L38 15.763l-7.743-3.114 1.145-8.186-7.956 2.535z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "m12 18.133 1.4-1.467 3.5 2.934 7.7-6.6 1.4 1.466L16.9 24z"
  }))));
};
export default SvgCheckmark;